module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPartial) ? _c('aside', {
    staticClass: "footer grid"
  }, [_c('div', {
    staticClass: "grid--container"
  }, [_c('div', {
    staticClass: "footer--row"
  }, _vm._l((_vm.plugins), function(plugin, index) {
    return (!_vm.isMobile || !plugin.content.hide_on_mobile) ? _c('div', {
      staticClass: "footer--col"
    }, [_c('div', {
      staticClass: "footer--section-wrapper"
    }, [_c(_vm.viewportDependentWrapper, {
      tag: "component",
      attrs: {
        "is-active": _vm.accordionStates[index],
        "passive-mode": true
      },
      on: {
        "request-change": function($event) {
          _vm.updateState(index, $event)
        }
      },
      scopedSlots: _vm._u([{
        key: "head",
        fn: function(props) {
          return [_c('span', {
            staticClass: "footer--section-header",
            class: [props.isActive ? 'footer--section-header__is-open' : '']
          }, [_c('h2', {
            staticClass: "u-reset footer--section-title",
            domProps: {
              "textContent": _vm._s(plugin.content.title)
            }
          }), _vm._v(" "), (_vm.isMobile) ? _c('cmp-icon', {
            staticClass: "footer--section-icon",
            attrs: {
              "symbol": "navigation_mobile_down",
              "size": "x-small"
            }
          }) : _vm._e()], 1)]
        }
      }])
    }, [_c(plugin.type, {
      tag: "component",
      attrs: {
        "slot": "body",
        "plugin": plugin
      },
      slot: "body"
    })], 1)], 1)]) : _vm._e()
  }))])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ef8e7eb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef8e7eb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-placeholders/footer/index.vue
// module id = 592
// module chunks = 7